import type { ReactNode } from 'react';
import { site } from '../config/site';

function isLiveStoreUrl(url: string | undefined): url is string {
  return Boolean(url && !url.includes('id0000000000'));
}

function StoreBadge({
  label,
  sub,
}: {
  label: 'App Store' | 'Google Play';
  sub: string;
}) {
  const icon =
    label === 'App Store' ? (
      <svg viewBox="0 0 24 24" aria-hidden>
        <path
          fill="currentColor"
          d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
        />
      </svg>
    ) : (
      <svg viewBox="0 0 24 24" aria-hidden>
        <path
          fill="currentColor"
          d="M3.609 1.814 13.792 12 3.61 22.186a.75.75 0 0 1-.8-.05L2.2 11.4a.75.75 0 0 1 0-1.2L2.81 9.7a.75.75 0 0 1 .8-.05L13.792 12 3.61 1.814zM14.6 12.65l2.7 1.55a.75.75 0 0 1 0 1.3l-2.7 1.55-2.35-2.2 2.35-2.2zm0-1.3-2.35-2.2 2.35-2.2 2.7 1.55a.75.75 0 0 1 0 1.3l-2.7 1.55zM4.9 3.2l8.2 4.75L5.7 13.7 4.9 3.2zm0 17.6 8.2-4.75L5.7 10.3 4.9 20.8z"
        />
      </svg>
    );

  return (
    <>
      <span className="store-badge-icon">{icon}</span>
      <span className="store-badge-text">
        <span className="store-badge-sub">{sub}</span>
        <span className="store-badge-label">{label}</span>
      </span>
    </>
  );
}

export function StoreButtons() {
  const parts: ReactNode[] = [];
  const iosUrl = isLiveStoreUrl(site.iosAppUrl) ? site.iosAppUrl : null;
  const androidUrl = isLiveStoreUrl(site.androidAppUrl)
    ? site.androidAppUrl
    : null;

  if (iosUrl) {
    parts.push(
      <a
        key="ios"
        className="store-badge"
        href={iosUrl}
        rel="noopener noreferrer"
        target="_blank"
      >
        <StoreBadge label="App Store" sub="Download on the" />
      </a>,
    );
  } else {
    parts.push(
      <span
        key="ios"
        className="store-badge store-badge--soon"
        aria-label="App Store — coming soon"
      >
        <StoreBadge label="App Store" sub="Coming soon on the" />
      </span>,
    );
  }

  if (androidUrl) {
    parts.push(
      <a
        key="android"
        className="store-badge"
        href={androidUrl}
        rel="noopener noreferrer"
        target="_blank"
      >
        <StoreBadge label="Google Play" sub="Get it on" />
      </a>,
    );
  }

  return <div className="store-row">{parts}</div>;
}
